import 'slick-carousel/slick/slick.min';
import 'jquery-match-height/dist/jquery.matchHeight-min';


export class WpetListCpnt {
    constructor()
    {
        this.initializeViewMode();
        this.initializeNumberResults();
        this.initializeSlick();
        this.initializeMatchHeight();
        this.initializePagination();
        this.initializeFilters();
        this.initializeLinkOffer();
        this.initializeOfferMetaMobile();
        this.initializeFormSelect();
    }

    initializeViewMode()
    {
        let triggers = document.querySelectorAll('.js-trigger-mode'),
            list = document.querySelectorAll('.wpetList')[0];

        if (triggers.length > 0) {

            triggers.forEach(trigger => trigger.addEventListener('click', (e) => {

                let classMode = e.currentTarget.getAttribute('data-mode');
                list.classList.remove('wpetModeMap', 'wpetModeList', 'wpetModeMixed');
                list.classList.add(classMode);
                window.wpet_map_object.mapObject.resize();

                $(document).trigger('wpet_change_mode');
            }));
        }
    }

    initializeNumberResults()
    {
        $(document).bind('wpet_ajax_build', (e,data) => {

            if ( $( '.js-wpetTotalNumber' ).length > 0 ) {
                $( '.js-wpetTotalNumber' ).text( data.total_global );
            }
        });
    }
    
    initializeSlick() {
        let slider = $('.wpetOfferSliderList'),
            sliderItem = $('.wpetOfferSliderItem');

        let settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false
        };
        $('.wpetOfferSliderList').slick(settings);

        $(document).on('wpet_ajax_build', () => {
            // $('.wpetOfferSliderList').slick('unslick');
            $('.wpetOfferSliderList').slick(settings);
        });

        $(document).on('wpet_change_mode', () => {
            $('.wpetOfferSliderList').slick('unslick');
            $('.wpetOfferSliderList').slick(settings);
        });
    }
    
    initializeMatchHeight() {
        let $item = $('[data-mh]');

        if ($('[data-mh]').length > 0) {
            $('[data-mh]').matchHeight({byRow: true});
        }

        $(document).on('wpet_ajax_build', () => {
            setTimeout(() => {
                $('[data-mh]').matchHeight({byRow: true});
            }, 100);
        });

        $( document ).on( 'wpet_ajax_navigation', () => {
            setTimeout( () => {
                $('[data-mh]').matchHeight( {
                    byRow: true
                } );
            }, 100 );
        } );

        $( document ).on( 'wpet_change_mode', () => {
            setTimeout( () => {
                $('[data-mh]').matchHeight( {
                    byRow: true
                } );
            }, 100 );
        } );
    }

    initializePagination()
    {
        let $wpet       = $('.wpetList');

        $(document).on('wpet_ajax_navigation', function() {

            $('html, body').animate({
                scrollTop: $wpet.offset().top
            }, 300);
        });

        $(document).on('wpet_ajax_build', function() {

            $('html, body').animate({
                scrollTop: $wpet.offset().top
            }, 300);
        });
    }

    initializeFilters()
    {
        let $jsWpetListFiltersButton = $('.js-wpetFiltersButton'),
            $body = $('body');

        $jsWpetListFiltersButton.on('click', function(e) {
            e.preventDefault();
            $body.addClass('isWpetFiltersOpen');
        });

        $('.wpetFiltersOverlay, .js-wpetFiltersClose').on('click', function(e) {
            e.preventDefault();
            $body.removeClass('isWpetFiltersOpen');
        });

        $(document).on('wpet_ajax_build', function() {
            $body.removeClass('isWpetFiltersOpen');
        });
    }

    initializeLinkOffer()
    {
        if( $('.jsLinkOffer').length > 0 ) {
            $( document ).on('click', '.jsLinkOfferItem', function(e) {
                
                var url = $(this).parents('.jsLinkOffer').find("a").attr("href");
                window.location = url;
            });
        }
    }

    initializeOfferMetaMobile() {
        $('.wpetList').on('click', '.js-triggerOfferMeta', function(e) {

            e.preventDefault();

            if( $(this).parents('.wpetOffer').hasClass('isOfferMetaActive') ) {
                $('.wpetOffer').removeClass('isOfferMetaActive');

            } else {
                $('.wpetOffer').removeClass('isOfferMetaActive');
                $(this).parents('.wpetOffer').addClass('isOfferMetaActive');
            }
        });
    }
    
    initializeFormSelect() {
        $(document).on('wpet_ajax_build', () => {
            $('select').parent().not('.formSelect').children('select').wrap('<div class="formSelect"></div>');
        });

        $( document ).on( 'wpet_ajax_navigation', () => {
            $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
        } );

        $( document ).on( 'wpet_change_mode', () => {
            $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
        } );
    }
}
